import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { suppressResizeObserverErrors } from "@/utils/errorSuppression";

// Suppress ResizeObserver errors before React loads
suppressResizeObserverErrors();

// Additional error suppression for React error boundary
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver')) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
